import { DatePicker, Modal } from "@truevault/aquilo";
import React, { useState } from "react";
import ConfettiComponent from "../../../common/components/Confetti";
import { useUpdateNoticeApi } from "./EditPrivacyCenter";
import moment from "moment";
import { PrivacyCenterNoticeDto } from "../../../common/service/server/dto/PrivacyCenterDto";

export const usePrivacyCenterPublish = (
  orgId: string,
  draftNotice: PrivacyCenterNoticeDto,
  refreshDraftNotice: () => Promise<void>,
): {
  isDateSaving: boolean;
  setIsDateSaving: (value: boolean) => void;
  onDateChange: (newDate: Date) => Promise<void>;
} => {
  const { updateNotice } = useUpdateNoticeApi();

  const [isDateSaving, setIsDateSaving] = useState(false);

  const onDateChange = async (newDate: Date) => {
    setIsDateSaving(true);

    const dateStr = moment(newDate).format("MM/DD/YYYY");

    await updateNotice({
      organizationId: orgId,
      privacyCenterId: draftNotice.privacyCenterId,
      noticeId: draftNotice.publicId,
      updateNoticeBody: {
        publishedAt: dateStr,
      },
    });
    await refreshDraftNotice();

    setIsDateSaving(false);
  };

  return { isDateSaving, setIsDateSaving, onDateChange };
};

export const PrivacyCenterPublishDatePickerModal = ({
  onPublishClick,
  closeModal,
  publishedAtDate,
  onDateChange,
  disabled = false,
}: {
  onPublishClick: () => Promise<void>;
  closeModal: () => void;
  publishedAtDate: Date;
  onDateChange: (date: Date) => Promise<void>;
  disabled?: boolean;
}) => {
  return (
    <Modal
      showOverlay
      firstButton="Go Back"
      firstButtonColor="tertiary"
      onFirstButtonClick={closeModal}
      secondButton="Publish"
      secondButtonColor="primary"
      onSecondButtonClick={() => {
        closeModal();
        onPublishClick();
      }}
      closeButton
      onClose={closeModal}
      alignButton="right"
      alignText="left"
    >
      <div className="publish-notice-modal">
        <h2 className="title">You are about to publish your policy!</h2>
        <p className="body">You can always come back and make revisions if needed.</p>
        <DatePicker
          date={publishedAtDate}
          label="Policy will be dated for"
          onChange={onDateChange}
          disabled={disabled}
        />
      </div>
    </Modal>
  );
};

export const PrivacyCenterFirstPublishSuccessModal = ({
  closeModal,
}: {
  okClick: () => void;
  closeModal: () => void;
}) => {
  return (
    <Modal
      title={"Your Privacy Center looks great - now let's get everything added to your website!"}
      body="Visit the Developer Instructions to complete your implementation."
      widthButton="full"
      showOverlay
      closeButton
      closeOnOverlayClick
      onClose={closeModal}
    >
      <>
        <img
          className="w-[347px] h-[264px] mx-auto"
          src="/assets/images/stay_compliant/privacy_center/first-publish-illustration.svg"
          alt="First publish success"
        />
        <ConfettiComponent />
      </>
    </Modal>
  );
};
